import { FC } from 'react'
import styles from './Pod4CoolingPower.module.scss'
import { Pod4CoolingPowerProps } from './types'
import cx from 'classnames'
import { Pod4Benefits } from 'components/Pod4Benefits'
import { VideoGif } from 'components/basic/VideoGif'
import { useRootStore } from 'components/_hooks/useRootStore'
import { observer } from 'mobx-react'

export const CoolingPowerConnected = observer(() => {
	const { metricRegion } = useRootStore().settingsStore
	return <Pod4CoolingPower metric={metricRegion} />
})

export const Pod4CoolingPower: FC<Pod4CoolingPowerProps> = (props) => {
	const { metric } = props

	const numDegrees = metric ? '10' : '20'

	return (
		<div className={styles.container}>
			<div className={styles.overlay} />
			<div className={styles.header}>
				<div className={styles.pill}>New</div>
				<div className={styles.title}>Now with 2x more cooling power</div>
			</div>
			<div className={cx(styles.description, styles.descriptionTop)}>A redesign of the Hub and Cover enables double the cooling power of the Pod.</div>
			<div className={styles.description}> Pod 4 can now cool up to {numDegrees} degrees below room temperature.</div>

			<Pod4Benefits metric={metric} />

			<VideoGif
				src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/tubes_new_blue_beautiful.mp4'}
				className={styles.coolingVideo}
			/>
		</div>
	)
}
